import request from '@/utils/request'

export function getCostList(data) {
  return request.post('/wxfwh/cost-list', data)
}



// WEBPACK FOOTER //
// ./src/api/cost.js